/** Utah's words for products.ts: the citation labels on the food-truck water, hose and fuel purposes. */
export const PRODUCTS_UT = {
  /** The state name as a source label in a research-row citation ("Utah, FDA"). */
  stateLabel: "Utah",
  /** R392-102-7(13): flush and sanitize a truck's water tank, pump and hoses when new, after repairs, and after 30 days unused. */
  flushCite: "Utah R392-102-7(13)",
  /** The state food truck rule as a research-row source label (R392-102: water tank, hose and cap lines EQ303-EQ306). */
  truckRuleLabel: "Utah R392-102",
  /** The county guideline source label for the truck hose and caps (Salt Lake County guideline, EQ303/EQ305). */
  countyLabel: "Salt Lake County",
  /** The state fire checklist label: no fueling with the public near, approved gasoline container (IFC 313.1.1). */
  fireChecklistLabel: "Utah fire checklist",
  /** The city utility a truck/shop recycles waste oil through, as a research-row source label (EQ343). */
  wasteOilLabel: "Salt Lake City Public Utilities",
} as const;
